(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/shared/components/content.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/shared/components/content.js');
"use strict";


const {
  checkLoggedIn
} = svs.eInstant.util;
setGlobal('svs.eInstant.shared.info.onLinkClicked', (url, isDemo) => {
  const isWillNavigate = checkLoggedIn(isDemo, svs.core.data.baseUrl + url);
  if (isWillNavigate) {
    svs.components.loader.show();
    window.location.href = svs.core.data.baseUrl + url;
  }
});
const GameInfoImage = _ref => {
  let {
    alt,
    image
  } = _ref;
  const {
    Image
  } = svs.content.image_v2;
  if (!image) {
    return null;
  }
  return React.createElement(Image, {
    alt: alt,
    cssSelectors: "e-instant-game-info-img",
    image: image
  });
};
const GameInfoImageGameInfoMemo = React.memo(GameInfoImage);
const Content = () => {
  const {
    useContext
  } = React;
  const {
    useHistory
  } = ReactRouterDOM;
  const {
    onPlay
  } = svs.eInstant.util;
  const {
    game
  } = useContext(svs.eInstant.shared.info.InfoContext);
  const history = useHistory();
  const {
    GridRow,
    GridCol
  } = svs.ui.ReactGrid;
  const Button = svs.ui.ReactButton;
  const {
    name,
    isInverted,
    infoImage,
    description,
    demoUrl,
    minPrice,
    maxPrice,
    playUrl,
    maxWin,
    legalText,
    trackingName
  } = game;
  const fcColorClass = "fc-".concat(isInverted ? 'black' : 'white');
  const isDesktop = svs.core.detect.formfactor.desktop();
  const prices = minPrice + (maxPrice && "-".concat(maxPrice));
  return React.createElement("div", {
    className: "e-instant-game-info-content ".concat(fcColorClass)
  }, React.createElement(GameInfoImageGameInfoMemo, {
    alt: name,
    image: infoImage
  }), React.createElement("div", {
    className: "e-instant-game-info-info"
  }, React.createElement("div", {
    className: "e-instant-game-info-text-content"
  }, React.createElement("h1", {
    className: "".concat(fcColorClass, " ").concat(isDesktop ? 'f-900 padding-top-4' : 'f-800 padding-top-3', " margin-bottom-1"),
    itemProp: "name"
  }, name), React.createElement("p", {
    className: "e-instant-game-info-desc ".concat(isDesktop ? 'f-600' : 'f-400'),
    itemProp: "description"
  }, description), React.createElement(GridRow, {
    className: "padding-top-1",
    xs: {
      gutter: 1
    }
  }, React.createElement(GridCol, {
    xs: 6
  }, React.createElement(Button, {
    block: true,
    className: "e-instant-info-action",
    "data-name": name,
    "data-playtype": "demo",
    "data-testid": "demo-button",
    "data-track": trackingName,
    href: demoUrl,
    inverted: !isInverted,
    onClick: e => {
      e === null || e === void 0 || e.preventDefault();
      onPlay(e, history, () => svs.eInstant.shared.info.onLinkClicked(demoUrl, true));
    },
    size: 300,
    title: "Provspela",
    transparent: true
  }, "Provspela")), React.createElement(GridCol, {
    itemProp: "offers",
    itemScope: true,
    itemType: "http://schema.org/Offer",
    xs: 6
  }, React.createElement("meta", {
    content: minPrice,
    itemProp: "price"
  }), React.createElement("meta", {
    content: "SEK",
    itemProp: "priceCurrency"
  }), React.createElement(Button, {
    block: true,
    className: "e-instant-info-action",
    "data-minprice": minPrice,
    "data-name": name,
    "data-playtype": "play",
    "data-testid": "play-button",
    "data-track": trackingName,
    href: playUrl,
    inverted: isInverted,
    itemProp: "url",
    onClick: e => {
      e === null || e === void 0 || e.preventDefault();
      onPlay(e, history, () => svs.eInstant.shared.info.onLinkClicked(playUrl, false));
    },
    size: 300,
    title: "Spela ".concat(name)
  }, "Spela"))), React.createElement("div", {
    className: "align-center padding-3"
  }, React.createElement("a", {
    className: "".concat(fcColorClass, " f-400 e-instant-pause24 js-pause24-trigger"),
    href: ""
  }, "SPELPAUS24")), React.createElement(GridRow, null, React.createElement(GridCol, {
    className: "align-center",
    xs: 6
  }, React.createElement("span", {
    className: "block f-500 e-instant-game-info-title"
  }, "INSATS"), React.createElement("span", {
    className: "f-800 f-bold"
  }, prices, ' ', "kr")), React.createElement(GridCol, {
    className: "align-center",
    xs: 6
  }, React.createElement("span", {
    className: "block f-500 e-instant-game-info-title"
  }, "MAXVINST"), React.createElement("span", {
    className: "f-800 f-bold"
  }, "".concat(svs.utils.format.Currency(maxWin), " kr")))), legalText && React.createElement("p", {
    className: "e-instant-info-legal padding-top-3 margin-bottom-0 margin-sm-bottom-3"
  }, legalText))));
};
setGlobal('svs.eInstant.shared.info.Content', Content);

 })(window);